import { create } from "zustand";

export const usePopoverStore = create((set) => ({
   anchorEl: null,

   setAnchorEl: (el) => set({ anchorEl: el }),
   clearAnchorEl: () => set({ anchorEl: null }),

   openPopover: (el) => set({ anchorEl: el }),
   closePopover: () => set({ anchorEl: null }),
   handleClick: (event) => set({ anchorEl: event.currentTarget })
}));
